// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"ca4d0c65de6551900cdd","691":"38eef5bab1de50348c39"}[chunkId] + ".js";
};